import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Spacer, rem } from 'design-system';
import LogoBankAccount from 'design-system/LogoBankAccount';
import Text from 'design-system/Text';
const BankNameRow = ({ data, style }) => {
    const { name } = data;
    return (<View style={[styles.bankNameRow, style]}>
      <LogoBankAccount size="R44" data={data} onCard/>
      <Spacer w={16}/>
      <Text Text-16 numberOfLines={1} style={styles.bankName}>
        {name}
      </Text>
    </View>);
};
const styles = StyleSheet.create({
    bankNameRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    bankName: {
        flex: 1,
        flexGrow: 1,
        flexShrink: 1,
        marginRight: rem(8),
    },
});
export default BankNameRow;
